import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Paper } from '@material-ui/core';
import { TabBar } from './TabBar';
import {
  AdvancedSettings,
  Affordable,
  Amenities,
  Leasing,
  Overview,
} from './TabViews';
import PropertyTabStatusController from './PropertyTabsStatusController';
import { useFeatureFlagContext } from '../../../../Context/FeatureFlagContext';
import { propertyPropTypes } from '../prop-types';
import { makeCss } from '../../../../knock-design-system';
import { TAB_LIST, TABS } from '../constants';

const useCss = makeCss({
  card: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  paper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
});

const PropertyTabs = ({
  errorMessage,
  isLoading,
  property,
  updateProperty,
}) => {
  const css = useCss();
  const [selectedTab, setSelectedTab] = useState(TABS.OVERVIEW);
  const { isAffordableLeasingEnabled } = useFeatureFlagContext();

  const activeTabs = TAB_LIST.filter(
    (tab) => tab !== TABS.AFFORDABLE || isAffordableLeasingEnabled
  );

  const { affordable, amenities, leasing } = property;

  const handleOnTabChange = (_e, tabValue) => {
    setSelectedTab(tabValue);
  };

  return (
    <Paper css={css.paper} variant="outlined">
      <PropertyTabStatusController
        errorMessage={errorMessage}
        isEmpty={!property.propertyId}
        isLoading={isLoading}
      >
        <div>
          <TabBar
            handleOnTabChange={handleOnTabChange}
            selectedTab={selectedTab}
            tabList={activeTabs}
          />
        </div>

        <Card css={css.card} elevation={0} role="tabpanel">
          {selectedTab === TABS.ADVANCED && (
            <AdvancedSettings
              advancedSettings={property[TABS.ADVANCED]}
              updateProperty={updateProperty}
            />
          )}
          {selectedTab === TABS.AFFORDABLE && (
            <Affordable
              affordable={affordable}
              updateProperty={updateProperty}
            />
          )}
          {selectedTab === TABS.AMENITIES && (
            <Amenities amenities={amenities} />
          )}
          {selectedTab === TABS.LEASING && <Leasing leasing={leasing} />}
          {selectedTab === TABS.OVERVIEW && (
            <Overview
              overview={property[TABS.OVERVIEW]}
              updateProperty={updateProperty}
            />
          )}
        </Card>
      </PropertyTabStatusController>
    </Paper>
  );
};

PropertyTabs.propTypes = {
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  property: propertyPropTypes,
  updateProperty: PropTypes.func,
};

export default PropertyTabs;
